import { api, defineWebModule } from '@itc/sdk';
import { getOrg, postCard, searchLibrary } from '../shared/endpoints.ts';

const drafts = () => import('./reports.ts');
const images = () => import('./cards.ts');

// The Library in the shell (design §7.5, plan 2E): the knowledge base, reports and
// Links, and the Verify on PTU widget on Home.
export default defineWebModule({
  name: 'library',
  title: 'Library',
  routes: [{ path: '/library', component: () => import('./pages/LibraryPage.vue'), meta: { permission: 'library.view', title: 'Library' } }],
  nav: [{ label: 'Library', to: '/library', permission: 'library.view', icon: 'library' }],
  widgets: [
    { id: 'library.countdown', title: 'Countdown', permission: 'authenticated', component: () => import('./widgets/CountdownWidget.vue') },
    { id: 'library.verify', title: 'Verify on PTU', permission: 'library.view', component: () => import('./widgets/VerifyWidget.vue') },
  ],
  orgInfo: () => api(getOrg),
  cardPost: {
    permission: 'library.post_cards',
    post: async (file, key) => {
      await api(postCard, { file }, { idempotencyKey: key });
    },
  },
  search: { permissions: ['library.view', 'library.view_reports'], run: async (q, signal) => (await api(searchLibrary, { query: { q } }, { signal })).hits },
  cards: [{ id: 'library.welcome', label: 'Welcome card', permission: 'library.view_reports', spec: async () => (await images()).welcomeImage() }],
  reports: [
    { type: 'intel', permission: 'library.manage_reports', draft: async () => (await drafts()).intel() },
    { type: 'incident', permission: 'library.manage_reports', draft: async () => (await drafts()).incident() },
  ],
});
